"use strict";

exports.__esModule = true;
exports.PlantInfoLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _API = require("../../API");
var _Core = require("../../Core");
var _TimeContext = require("../../Time/TimeContext");
var _TicketTypes = require("../../TicketTypes");
var _UserListContext = require("../../User/UserListContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _DeviceTagListContext = require("../../Device/DeviceTagListContext");
var _PlantStateActivities = require("../../PlantStateActivities");
var _Utils = require("../../../Utils");
var _DeviceTypeListContext = require("../../Device/DeviceTypeListContext");
var _PlantTwinContext = require("../../PlantTwin/PlantTwinContext");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _timeDefinitions = require("../../timeDefinitions");
var _dec, _dec2, _class, _PlantInfoLoader;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var REFRESH_TIMER_INTERVAL = (0, _timeDefinitions.getMinutesMillis)(5);

/**
 * Loads core information about a plant via the API.
 */
var PlantInfoLoader = exports.PlantInfoLoader = (_dec = _API.RestAPIContext.withContext, _dec2 = _DataAccessorContext.DataAccessorContext.withContext, _dec(_class = _dec2(_class = (_PlantInfoLoader = /*#__PURE__*/function (_Component) {
  function PlantInfoLoader() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      lastFetch: Date.now(),
      fetchAtDelta: 0
    };
    _this.hasMounted = false;
    _this.onData = function (data) {
      var time = data.time;
      var currentWorkday = time.currentWorkday;
      _this.setState({
        fetchAtDelta: currentWorkday.interval.endMillis - Date.now()
      }, function () {
        if (typeof _this.fetchTimeoutID === "number") {
          clearTimeout(_this.fetchTimeoutID);
        }
        _this.fetchTimeoutID = setTimeout(function () {
          if (!_this.hasMounted) {
            return;
          }
          _this.setState({
            lastFetch: Date.now()
          });
        }, _this.state.fetchAtDelta);
      });
    };
    _this.load = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$props, api, dataAccessor, _yield$Promise$all, time, deviceTags, allDevices, plantTwin, plantStateActivities, plantStateActivitiesDevices, userList, ticketTypes, deviceTypes, enabledDevices;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$props = _this.props, api = _this$props.api, dataAccessor = _this$props.dataAccessor;
            _context.n = 1;
            return Promise.all([(0, _TimeContext.fetchPlantTime)(dataAccessor), (0, _DeviceTagListContext.fetchDeviceTagList)(dataAccessor), (0, _DeviceListContext.fetchAllDevices)(dataAccessor), (0, _PlantTwinContext.fetchHierarchy)(api), (0, _PlantStateActivities.fetchPlantStateActivities)(dataAccessor), (0, _PlantStateActivities.fetchPlantStateActivitiesDevices)(dataAccessor), (0, _UserListContext.fetchUserList)(dataAccessor), (0, _TicketTypes.fetchTicketTypes)(api), (0, _DeviceTypeListContext.fetchDeviceTypeList)(api)]);
          case 1:
            _yield$Promise$all = _context.v;
            time = _yield$Promise$all[0];
            deviceTags = _yield$Promise$all[1];
            allDevices = _yield$Promise$all[2];
            plantTwin = _yield$Promise$all[3];
            plantStateActivities = _yield$Promise$all[4];
            plantStateActivitiesDevices = _yield$Promise$all[5];
            userList = _yield$Promise$all[6];
            ticketTypes = _yield$Promise$all[7];
            deviceTypes = _yield$Promise$all[8];
            // A disabled device exists only on the Devices settings pages, which fetch
            // their own list. Every other screen reads one of these three contexts, so
            // this is the one place that hides disabled devices across the product.
            enabledDevices = allDevices.filter(function (device) {
              return device.enabled;
            });
            return _context.a(2, {
              time: time,
              deviceTags: deviceTags,
              devices: enabledDevices,
              plantTwin: plantTwin,
              plantStateActivities: plantStateActivities,
              plantStateActivitiesDevices: plantStateActivitiesDevices,
              userList: userList,
              ticketTypes: ticketTypes,
              deviceTypes: deviceTypes,
              allDevices: enabledDevices,
              allEnabledDevices: enabledDevices
            });
        }
      }, _callee);
    }));
    return _this;
  }
  _inheritsLoose(PlantInfoLoader, _Component);
  var _proto = PlantInfoLoader.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.hasMounted = true;
    if (typeof this.stopTimer === "function") {
      this.stopTimer();
    }
    this.stopTimer = (0, _Utils.createTimer)(function () {
      if (!_this2.hasMounted) {
        return;
      }
      _this2.setState({
        lastFetch: Date.now()
      });
    }, REFRESH_TIMER_INTERVAL);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hasMounted = false;
    if (typeof this.stopTimer === "function") {
      this.stopTimer();
      this.stopTimer = undefined;
    }
    if (typeof this.fetchTimeoutID === "number") {
      clearTimeout(this.fetchTimeoutID);
    }
  };
  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
      load: this.load,
      params: this.state.lastFetch,
      onData: this.onData
    }, function (_ref2) {
      var loaded = _ref2.loaded,
        fetching = _ref2.fetching,
        error = _ref2.error,
        data = _ref2.data;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fetching && !data && !loaded && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null), error && /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error,
        title: "Error loading plant info."
      }), loaded && data && children(data));
    });
  };
  return PlantInfoLoader;
}(_react.Component), _PlantInfoLoader.defaultProps = {
  api: undefined,
  dataAccessor: undefined
}, _PlantInfoLoader)) || _class) || _class);